import styled from '@emotion/styled';
import { TextButton } from '../../components/button/old';
import { TopBar as TopBarNew } from './TopBar';
import { top_bar_action_button_css } from './styles';

export const TopBar = {
  ...TopBarNew,
  ActionButton: styled(TextButton)(top_bar_action_button_css),
};
